import { render, staticRenderFns } from "./ztp-templates-card.vue?vue&type=template&id=f80aa3c2&scoped=true"
import script from "./ztp-templates-card.vue?vue&type=script&lang=ts"
export * from "./ztp-templates-card.vue?vue&type=script&lang=ts"
import style0 from "./ztp-templates-card.vue?vue&type=style&index=0&id=f80aa3c2&prod&lang=css&scoped=true"
import style1 from "./ztp-templates-card.vue?vue&type=style&index=1&id=f80aa3c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80aa3c2",
  null
  
)

export default component.exports